export default __webpack_public_path__ + "static/media/emp.27df260a.png";